<template>
  <div ref="target" class="news-list">
    <div class="left">
      <div class="top">
        <div class="top-carousel">
          <NewsCarousel :bannerList="bannerList" />
          <DomainList :domainList="domainList" />
        </div>
      </div>
      <div class="bottom">
        <NewsVideo :list="list" />
      </div>
    </div>
    <div class="middle">
      <PolicyNews :policyList="policyList" :domainList="domainList" />
    </div>
    <div class="right">
      <NoticeNews :noticeList="noticeList" :domainList="domainList" />
      <div class="notes">
        <NewsTests :testList="testList" />
      </div>
    </div>
  </div>
</template>

<script>
import NewsVideo from "../newsvideo/news-video";
import NewsTests from "../newstests/news-tests";
import DomainList from "../common/domain-list.vue";
import NewsCarousel from "../common/new-carousel.vue";
import PolicyNews from "../common/policy-news.vue";
import NoticeNews from "../common/notice-news.vue";
import { findNewsVideo, findNewsTests } from "@/api/news";
import { useLazyData, useLazyNewsTests } from "@/hooks/index";
import { computed, ref, onUnmounted } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    NewsVideo,
    NewsTests,
    DomainList,
    NewsCarousel,
    PolicyNews,
    NoticeNews,
  },
  props: {
    policyList: {
      type: Object,
      default: () => {},
    },
    noticeList: {
      type: Object,
      default: () => {},
    },
    bannerList: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const store = useStore();
    //获取主治医师数组中的随机数
    const clID = ref(1758);
    const target = ref(null);
    let intervalId = null;
    let zhuzhiyishi = [
      1758, 1552, 1794, 1785, 1792, 1791, 1759, 1757, 1796, 1783, 1784, 1763,
      1550, 1795, 1790, 1788, 1793, 1760, 1798, 1549, 1746, 1797, 1745, 1789,
      1787, 1765, 1766, 1764, 1612, 1749, 1744, 1551, 1613, 1743, 1756, 1614,
      1753, 1752, 1754, 1755, 1762, 1782, 1750, 1748, 1747, 1751, 8157,
    ];

    function getRandomNumber(arr) {
      const randomIndex = Math.floor(Math.random() * arr.length);
      return arr[randomIndex];
    }

    intervalId = setInterval(() => {
      clID.value = getRandomNumber(zhuzhiyishi);
    }, 3000);
    const { result } = useLazyData(target, () =>
      findNewsVideo({ clID: [clID.value] })
    );
    const { testList } = useLazyNewsTests(target, () =>
      findNewsTests({ clID: [clID.value] })
    );
    const domainList = computed(() => {
      let list = store.state.category.list.find(
        (items) => items.clID === clID.value
      );

      return list;
    });

    onUnmounted(() => {
      // 清除定时器
      if (intervalId) {
        clearInterval(intervalId);
      }
    });
    return { target, testList, domainList, list: result };
  },
};
</script>

<style lang="less" scoped>
.news-list {
  height: 500px;
  //background: #f0e5e5;
  display: flex;
  justify-content: space-between;
  .left {
    width: 400px;
    height: 500px;
    display: flex;
    flex-direction: column;
    .top {
      width: 400px;
      height: 240px;
      .top-carousel {
        display: inline-block;
        width: 360px;
        height: 130px;
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 15px;
        border-radius: 5px;
        a {
          img {
            border-radius: 5px;
          }
        }
      }
    }

    .bottom {
      width: 400px;
      height: 250px;
      .recommend {
        display: flex;
        height: 50px;
        align-items: center;
        justify-content: space-between;
        background: rgb(244, 244, 244);
        h3 {
          margin-left: 10px;
        }
        .more {
          a {
            display: flex;
            align-items: center;
            margin-right: 10px;
            color: #999;
            &:hover {
              color: @shColor;
            }
          }
        }
      }
      .recommend-cate {
        display: flex;
        height: 210px;
        justify-content: space-between;
      }
    }
  }
  .middle {
    margin-top: 15px;
    width: 400px;
    overflow: hidden;
    border: 1px solid rgb(244, 244, 244);
  }
  .right {
    margin-top: 15px;
    width: 400px;

    .notes {
    }
  }
}
</style>
